import React, { useEffect, useState } from 'react';
import API from '../../utils/api';
import { useFailedImages } from '../../hooks/useFailedImages';
import { getCategoryIcon } from '../../utils/categoryIcons';
import './ServiceCardGrid.css';

const SERVER_URL = (API.defaults?.baseURL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');
const imgUrl = path => (path && path.startsWith('/') ? `${SERVER_URL}${path}` : path);
const DEFAULT_GLOW = 'var(--c-df9b08, #df9b08)';
// The accent colour is typed in the admin panel, so only accept a real hex colour.
const safeGlow = value => (/^#[0-9a-f]{3,8}$/i.test(String(value || '').trim()) ? String(value).trim() : DEFAULT_GLOW);

// Home page service tiles, drawn from the cards the admin manages (Service Cards in the admin panel):
// each card keeps its own image, accent colour, description, order and link.
// While loading it shows placeholders; with no cards at all it renders `fallback`.
const ServiceCardGrid = ({ onSelect, fallback, limit = 0, cols = 0, className = '', onCount }) => {
    const [cards, setCards] = useState(null);
    const [failedImages, markImageFailed] = useFailedImages();

    useEffect(() => {
        let cancelled = false;
        API.get('/service-cards')
            .then(res => { if (!cancelled) { const list = res.data.cards || []; setCards(list); onCount?.(list.length); } })
            .catch(() => { if (!cancelled) setCards([]); });
        return () => { cancelled = true; };
    }, []);

    if (cards === null) {
        return <div className="svc-grid" aria-busy="true">{[0, 1, 2, 3].map(i => <div className="svc-card is-loading" key={i} />)}</div>;
    }
    if (cards.length === 0) return fallback || null;
    const shown = limit ? cards.slice(0, limit) : cards;
    const gridStyle = cols ? { '--cols': cols } : undefined;

    return (
        <div className={`svc-grid ${className}`} style={gridStyle}>
            {shown.map(card => {
                const image = card.image ? imgUrl(card.image) : '';
                const hasImage = image && !failedImages.has(image);
                const PlaceholderIcon = getCategoryIcon(card.category || card.name);
                return (
                    <button type="button" className="svc-card" key={card._id} style={{ '--glow': safeGlow(card.glow) }} onClick={() => onSelect?.(card.category || '')}>
                        <span className="svc-card__body">
                        <span className="svc-card__hexwrap">
                            <span className="svc-card__hex">
                                {hasImage
                                    ? <img src={image} alt={card.name || card.category || 'Wedding service'} loading="lazy" onError={() => markImageFailed(image)} />
                                    : <span className="svc-card__ph" aria-hidden="true"><PlaceholderIcon /></span>}
                            </span>
                        </span>
                        <strong>{card.name}</strong>
                        {card.description && <p>{card.description}</p>}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default ServiceCardGrid;
